const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5.4658,
    height: 5.4658,
    viewBox: "0 0 1.4462 1.4462",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45)",
    cx: 0.0000050205,
    cy: 1.0226,
    r: 0.72309,
    style: {
      fillRule: "evenodd",
      fill: "#000000",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.75761.40097.28759-1.54e-6 1.6e-6.28759",
    style: {
      fill: "none",
      strokeWidth: 0.13229,
      stroke: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.40175 1.0443.64319-.64319",
    style: {
      fill: "none",
      strokeWidth: 0.13229,
      stroke: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.40098.7576-1.54e-6.28759.28759 1.5e-6",
    style: {
      fill: "none",
      strokeWidth: 0.13229,
      stroke: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.42169e892318db0748914d78b3410816.svg";
export { ForwardRef as ReactComponent };